import 'styleguide/styleguide-critical/revolve-magazine';
import {
  initRevolveMagazine, initSkipLinks, initStoryBars, onDomReady,
} from 'modules/revolve-magazine';
import initViewMore from 'modules/view-more';

onDomReady(() => {
  initRevolveMagazine();
  initSkipLinks();
  initStoryBars();
  initViewMore();
});



// WEBPACK FOOTER //
// ./src/scripts/entry-points/styleguide-critical/revolve-magazine.js